export const pushEcommerce = (data) => {
  try {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push(data);
  } catch (e) {
    console.log(e);
  }
};

export const pushDataLayerEvent = (event, data = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ event, ...data });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerAddToCart = (gtmEcommerceItems) => {
  try {
    pushEcommerce({
      event: "gtm_add_to_cart",
      ecommerce: {
        items: gtmEcommerceItems,
        currency: gtmEcommerceItems[0].currency,
        value: gtmEcommerceItems.reduce((p, v) => p + v.price * v.quantity, 0),
      }
    });
  } catch (e) {
    console.log(e);
  }
};

export const dataLayerGtmViewCart = (cart) => {
  try {
    pushEcommerce({
      'event': 'gtm_view_cart',
      'ecommerce': {
        'currency': cart.currency,
        'value': cart.gtmGrandTotal,
        'items': cart.gtmOrderRows,
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const priceShapeAddToCart = (priceshapeItems) => {
  try {
    pushEcommerce({
      event: "price_shape_add_to_cart",
      ecommerce: {
        items: priceshapeItems,
      }
    });
  } catch (e) {
    console.log(e);
  }
};
